import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import React, {useState} from 'react';
import {withStyles} from '@material-ui/core';
import LongTextButton from '../Text/LongTextButton';
import TowLine from '../Text/TwoLine';
import NoteListItem from './NoteListItem';
import TableBody from '@material-ui/core/TableBody';
import Hidden from '@material-ui/core/Hidden';

const NotesList = ({notes, ...rest}) => {

    return (
        <Table>
            <TableHead>
                <TableRow>
                    <TableCell scope="col">Datum / Mitarbeiter</TableCell>
                    <TableCell scope="col">Kontakt</TableCell>
                    <TableCell scope="col">Notiz</TableCell>
                    <Hidden mdDown>
                        <TableCell scope="col">Verknüpfung</TableCell>
                    </Hidden>
                </TableRow>
            </TableHead>
            <TableBody>
                {notes && notes.map((note, idx) => note && (<NoteListItem key={idx} note={note}/>))}
            </TableBody>
        </Table>
    );
};

const styles = theme => ({
    spacing: {
        marginTop: theme.spacing.unit * 2,
    },
    span: {
        display: 'inline',
        margin: '0 5px',
    },
});

export default withStyles(styles)(NotesList);
